import axios from "@/core/axios";
import Pusher from "pusher-js";

export const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    enabledTransports: ["ws"],
    authorizer: channel => {
        return {
            authorize: (socket_id, callback) => {
                return axios
                    .post("/api/guest/auth/pusher", {
                        socket_id: socket_id,
                        channel_name: channel.name
                    })
                    .then(data => {
                        callback(false, data);
                    });
            }
        };
    }
});
export let pusher_channel;

export default {
    install(Vue, options) {
        if (
            !process.env.VUE_APP_PUSHER_KEY ||
            !process.env.VUE_APP_PUSHER_CLUSTER
        ) {
            console.log("[DrPusher] No keys");
            return false;
        }

        pusher_channel = Vue.prototype.$pusher_channel = pusher.subscribe(
            `private-user-${options.user_uuid}`
        );
    }
};
